import {InnerPostcardAppPage} from "../components/app/postcard-app/InnerPostcardAppPage";

const PostcardAppPage = InnerPostcardAppPage

export default PostcardAppPage
